import { render, staticRenderFns } from "./HeaderDesk.vue?vue&type=template&id=28e7f31d&scoped=true&"
import script from "./HeaderDesk.vue?vue&type=script&lang=js&"
export * from "./HeaderDesk.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDesk.vue?vue&type=style&index=0&id=28e7f31d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7f31d",
  null
  
)

export default component.exports